import { app } from '../../app.module'
app
  // 投稿タグ管理モーダルを表示するためのボタン
  .directive('editPostTagButton', ($parse) => {
    return {
      restrict: 'E',
      template: require('./edit-post-tag-button.pug')(),
      controller: function ($rootScope, $scope, $mdDialog, $attrs) {
        // タグボタンをクリックした際の処理
        $scope.showModal = function () {
          if ($attrs.accountModalFlg === 'true') {
            $parse($attrs.tagButtonChange)($scope, {
              postId: $attrs.postId,
            })
            return
          }
          // モーダル用のスコープを新規に作成し、モーダル内で使用するパラメーターを格納
          const modalScope: {
            snsType: string
            postId: number
          } = $rootScope.$new()

          // SNS種別
          modalScope.snsType = $attrs.snsType
          // 投稿ID
          modalScope.postId = $attrs.postId

          // モーダルを表示する
          $mdDialog.show({
            template: require('./edit-post-tag-modal.pug')(),
            scope: modalScope,
            clickOutsideToClose: true,
          })
        }
      },
    }
  })
